<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-tasks"></i> Stock Opname
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-2">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/inventory-pendukungs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="stock" slot-scope="props">
                            <span :class="props.rowData.stock_warning ? 'text-danger font-weight-bold' : ''">
                                {{ props.rowData.stock }}
                                <i v-if="props.rowData.stock_warning" class="fas fa-exclamation-circle" :title="props.rowData.stock_warning"></i>
                            </span>
                        </template>
                        <template slot="stock_fisik" slot-scope="props">
                            <span v-if="props.rowData.opname" :class="props.rowData.opname.stock_warning ? 'text-danger font-weight-bold' : ''">
                                {{ props.rowData.opname.stock }}
                                <i v-if="props.rowData.opname.stock_warning" class="fas fa-exclamation-circle" :title="props.rowData.opname.stock_warning"></i>
                            </span>
                            <span v-else class="text-muted">
                                <i class="fas fa-question-circle"></i>
                            </span>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.status == 'Sama'" class="badge badge-success">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Stock Fisik Melebihi'" class="badge badge-info">{{ props.rowData.status }}</span>
                            <span v-else class="badge badge-danger">{{ props.rowData.status }}</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button v-if="$can('create stock opname')" type="button" title="Stock Opname" @click="stockOpname(props.rowData)" class="btn btn-link px-1"><i class="fas fa-weight"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :inventoryPendukung="currentInventoryPendukung" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import EditForm from './Form';

export default {
    name: "stock-opname",

    components: {
        SearchBar,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentInventoryPendukung: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            searchStatus: '',
            editModal: false,
            gudang: null,
        }
    },

    created() {
    },

    mounted() {
        if (this.userGudang) {
            this.loadGudang(this.userGudang.id);
        }
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'name',
                    title: 'Nama',
                    sortField: 'name',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'stock_minimal',
                    title: 'Stock Minimal',
                    sortField: 'stock_minimal',
                },
                {
                    name: '__slot:stock',
                    title: 'Stock by System',
                    sortField: 'stock',
                },
                {
                    name: '__slot:stock_fisik',
                    title: 'Stock Fisik',
                    sortField: 'stock_fisik',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                    sortField: 'status',
                },
                {
                    name: 'opname.user.name',
                    title: 'Stock Opname Oleh',
                    sortField: 'opname_user_name',
                    callback: 'formatValue',
                },
                {
                    name: 'opname.created_at',
                    title: 'Stock Opname Pada',
                    sortField: 'created_at',
                    callback: 'formatDatetime',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
                is_stock_opname: true,
                status: this.searchStatus,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.searchStatus = search.searchStatus;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.searchStatus = '';
            this.refresh();
        },

        addInventory() {
            this.currentInventoryPendukung = null;
            this.editModal = true;
        },

        stockOpname(rowData) {
            this.currentInventoryPendukung = Object.assign({}, rowData);
            this.editModal = true;
        },

        saved() {
            this.editModal = false;
            this.currentInventoryPendukung = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/inventory-pendukungs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },
    },
}
</script>
